class AdressFilter {
  
  constructor(){

    this.list  = document.querySelectorAll('[data-component="adresse"]');
    this.trigger  = document.querySelectorAll('[data-trigger]');
    this.triggerAll  = document.querySelector('[data-trigger="all"]');

    this.select  = document.querySelector('[data-select="filters"]');
    
    if (this.list) {
      this._init();
    }
	}

	_init(){
		for (let element of this.trigger) {
			element.addEventListener('click', (e)=> this.checkIfIsVisible(e) );
    }
    this.triggerAll.addEventListener('click', ()=> this.showAll() );
    
    this.select.addEventListener('change', (e)=> this.checkIfIsVisible(e) );

	}
  
  showAll () {
		for (let element of this.list) {
			element.setAttribute('data-state', 'visible');
    }
  }


	checkIfIsVisible(event) {
    let filter;
    if(event.target.hasAttribute('data-select')) {
      filter = event.target.value;
    } else {
      filter = event.target.getAttribute('data-trigger');
    }

    if (filter === '') {
      this.showAll();
    } else {
      this.handleIsActive(event.target);
      
      for (let element of this.list) {
        let itemTaxos = element.getAttribute('data-taxonomy').split(',');
  
        let isOk = false;
        for (let itemTaxo of itemTaxos) {
          if (itemTaxo === filter) {
            isOk = true;
            this.handleVisibility(element, isOk);
          }
        }
        this.handleVisibility(element, isOk);
      }
    }
  }

  handleVisibility(element, bool){
    bool === true ? element.setAttribute('data-state', 'visible') : element.setAttribute('data-state', 'hidden');
  }

  handleIsActive(target) {
    for (let element of this.trigger) {
			element.setAttribute('data-state', 'unchecked');
    }
    target.setAttribute('data-state', 'active');
  }

}

export const addressFilter = new AdressFilter();